/**
 * Schema.org Person JSON-LD. Two uses:
 *
 * <ol>
 *   <li>STANDALONE on instructor profile pages — Knowledge Graph entity
 *       + AI search grounding for "Who teaches X?" queries.</li>
 *   <li>HELPER for other schemas — Course's {@code instructor} field,
 *       Article's {@code author} field. Import {@link buildPersonSchema}
 *       directly and inline the result.</li>
 * </ol>
 */
import { JsonLdScript } from './_shared';

export interface PersonSchemaInput {
  name: string;
  image?: string;
  jobTitle?: string;
  description?: string;
  sameAs?: string[];
  url?: string;
}

export interface PersonSchemaJsonLdProps extends PersonSchemaInput {
  id?: string;
}

export function PersonSchemaJsonLd({ id, ...person }: PersonSchemaJsonLdProps) {
  const schema = buildPersonSchema(person);
  return <JsonLdScript schema={schema} id={id ?? 'schema-person'} />;
}

export function buildPersonSchema(person: PersonSchemaInput) {
  return {
    '@type': 'Person',
    name: person.name,
    image: person.image,
    jobTitle: person.jobTitle,
    description: person.description,
    sameAs: person.sameAs && person.sameAs.length > 0 ? person.sameAs : undefined,
    url: person.url,
  };
}
